<ul>
    <li *ngFor="let nv of decoded">{{ nv.name }}: <b>{{ nv.value }}</b></li>
</ul>